import { LIVE_MANAGE_PATH } from '../../path'

export const LIVE_STATUS = {
  '1': {
    color: '#f83244',
    text: '未提交'
  },
  '2': {
    color: '#ff801a',
    text: '审核中'
  },
  '3': {
    color: '#1b9515',
    text: '待直播'
  },
  '4': {
    color: '#f83244',
    text: '审核不通过'
  },
  '5': {
    color: '#333',
    text: '已直播'
  },
  '6': {
    color: '#1b9515',
    text: '待直播（正在预热）'
  }
}

const LIVE_FORM_PATH = `${LIVE_MANAGE_PATH}/reportForm`
const LIVE_CHECK_FORM_PATH = `${LIVE_MANAGE_PATH}/reportFormView`

// 审核状态 1未编辑 2待审核 3审核通过 4审核拒绝 5已直播 6 待直播（正在预热）
export const LIVE_STATUS_OPERATION = {
  '1': {
    path: LIVE_FORM_PATH,
    text: '编辑提报单'
  },
  '2': {
    path: LIVE_FORM_PATH,
    text: '编辑提报单'
  },
  '3': {
    path: LIVE_FORM_PATH,
    text: '编辑提报单'
  },
  '4': {
    path: LIVE_FORM_PATH,
    text: '编辑提报单'
  },
  '5': {
    path: LIVE_CHECK_FORM_PATH,
    text: '查看提报单'
  },
  '6': {
    path: LIVE_CHECK_FORM_PATH,
    text: '查看提报单'
  }
}
